<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <div class="handler">
        <el-tabs
          class="tab"
          v-model="currentCard"
          size="small"
          type="card"
          @tab-click="onTabClick"
        >
          <el-tab-pane v-for="item in headTabList" :label="item.name" :name="item.value" :key="item.value" lazy>
            <ReserveList v-if="item.value == 1" :info="item.dto" :ticketId="ticketId" :isEnd="isEnd"/>
            <ReserveList v-if="item.value == 2"  :info="item.dto" :ticketId="ticketId" :isEnd="isEnd"/>
            <HasReserve v-if="item.value == 3" :ticketId="ticketId" />
            <LimitReserve v-if="item.value == 4" :ticketId="ticketId" :isEnd="isEnd"/>
          </el-tab-pane>
        </el-tabs>
        <butn class="trash" btntype="primary" title="返回" @click="$router.push({path: '/courseTicketManage'})" iconName="el-icon-arrow-left"></butn>
      </div>
    </div>    
  </div>
</template>
<script>
import butn from "@/components/button/index";
import ReserveList from "./components/tabsChild/reserveList.vue";
import HasReserve from "./components/tabsChild/hasReserve.vue";
import LimitReserve from "./components/tabsChild/limitReserve.vue";
import { courseTicketById } from "@/api/resourceService"

export default {
  name: "courseTicketManageReserveMange",
  components: {
    butn,
    ReserveList,
    HasReserve,
    LimitReserve
  },
  
  data() {
    return {
      headTabList: [],
      details: [],
      currentCard: "1",
      ticketId: null,
      isLimit: 0,
      isEnd: 0,  // 预约是否结束（0否 1是）
    };
  },
  created() {
    this.initTabList();


  },
  methods: {

    initTabList() {
      let list = [];
      const { uuid, tab = null } = this.$route.query
      this.ticketId = uuid;
      courseTicketById(uuid).then(res => {
        if (res && res.code == 0) {
          const {isLimit, detailVos=[],  isEnd} = res.data
          this.details = detailVos;
          this.isLimit = isLimit;
          this.isEnd = Number(isEnd);
          this.details.forEach((item) => {
            if (item.bizType == 1) {
              list.push({name: '线上预约范围', value: '1', dto: item})
            }
            if (item.bizType == 2) {
              list.push({name: '线下预约范围', value: '2', dto: item})
            }
          })
          list.push({name: '已预约名单', value: '3'})
          if (isLimit == 1) {
            list.push({name: '限制预约名单', value: '4'})
          }
          this.headTabList = list;
          this.currentCard  = this.headTabList[0].value;
          if (tab >= 1 && tab <= 4) {
            this.currentCard = tab;
          } else {
            this.currentCard  = this.headTabList[0].value;
          }
        }
      })
      
    },

    onTabClick(val) {
    }

  }
};
</script>
<style lang="scss" scoped>

.filter_container {
  padding-top: 20px;
  padding-bottom: 15px !important;
}
.handler {
  position: relative;
  .trash {
    position: absolute;
    right: 0;
    top: 5px;
  }
}
</style>
